import { RouteConfig } from 'vue-router';

const list: Array<RouteConfig> = [
  {
    path: 'backup-plans',
    name: 'computeBackupPlans',
    component: () => import('@/self-service/pages/compute/backupPlans'),
    props: true,
    meta: {
      title: $t => $t('Backup plans'),
      href: 'backup-plans',
      hidden: true,
    },
    children: [
      {
        path: 'add',
        name: 'computeBackupPlanAdd',
        component: () => import('@/self-service/pages/compute/backupPlans/backupPlanAdd'),
        meta: {
          title: $t => $t('Create backup plan'),
          restrictions: {
            action: 'create',
            resource: 'compute_backup_plans'
          },
        }
      },
      {
        path: ':id/edit',
        name: 'computeBackupPlansEdit',
        component: () => import('@/self-service/pages/compute/backupPlans/backupPlanAdd'),
        props: true,
        meta: {
          title: $t => $t('Edit backup plan'),
          restrictions: {
            action: 'update',
            resource: 'compute_backup_plan'
          },
        }
      },
      {
        path: ':id/:detailsTab(overview|volumes)?',
        name: 'computeBackupPlanDetails',
        meta: {
          title: $t => $t('Backup plan details')
        },
      }
    ]
  },
  {
    path: 'recovery-points',
    name: 'computeBackupRecoveryPoints',
    component: () => import('@/self-service/pages/compute/recoveryPoints'),
    props: true,
    meta: {
      title: $t => $t('Recovery points'),
      href: 'recovery-points',
      hidden: true,
    },
    children: [
      {
        path: ':id',
        name: 'computeBackupRecoveryPointDetails',
        meta: {
          title: $t => $t('Recovery point details')
        },
      }
    ]
  }
];

export default list;
